import { Component, OnInit, TemplateRef, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';
import { PopupRef, PopupContent } from '../../popup/popup.ref';

@Component({
  selector: 'app-popup',
  templateUrl: './popup.component.html',
  styleUrls: ['./popup.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PopupComponent implements OnInit {
  renderMethod: 'template' | 'component' | 'text' = 'component';
  content: PopupContent;
  context: any;

  constructor(
    private popupRef: PopupRef
  ) { }

  ngOnInit() {
    this.content = this.popupRef.content;
    
    if (typeof this.content === 'string') {
      this.renderMethod = 'text';
    } else if (this.content instanceof TemplateRef) {
      this.renderMethod = 'template';
      this.context = {
        close: this.popupRef.close.bind(this.popupRef)
      };
    }
  }
}
